// The following code is style-only so regressions will not be caught by a Jest unit test
/* istanbul ignore file */

import styled, { css } from 'styled-components';
import { Space } from 'src/utils/theme';

interface CenterProps {
  /**
   * DO NOT USE DIRECTLY.
   *
   * This is only for styled-components to use indirectly.
   * Please do not pass values to this prop directly.
   */
  className?: string;

  $maxWidth?: Space;

  /**
   * Minimum distance between the children of this component
   * and the parent of this component. The distance to
   * the parent's border will become much larger when the
   * screen width increases (as a combination of margin and
   * padding).
   */
  $paddingX?: Space;

  /**
   * When this prop is true, the content is centered within
   * the column that the <Center /> component creates.
   *
   * When this prop is false, only the column itself is
   * centered.
   *
   * This becomes relevant when children are smaller than
   * the width of <Center />
   */
  $centerAlignItems?: boolean;
}

export const Center = styled.div<CenterProps>(
  ({ theme, $maxWidth = 'xxl', $paddingX = 's0', $centerAlignItems = false }) => {
    return css`
      box-sizing: content-box;
      margin-left: auto;
      margin-right: auto;
      max-width: ${theme.sz[$maxWidth]};
      padding: 0 ${theme.sz[$paddingX]};

      ${$centerAlignItems &&
      `
        display: flex;
        flex-direction: column;
        align-items: center;
      `}
    `;
  },
);

export default Center;
